module.exports = __webpack_public_path__ + "img/icon1.417687f8.jpg";